import bookingCard from '/public/dashboard/bookingCard.svg';
import profileCard from '/public/dashboard/profileCard.svg';
import paymentCard from '/public/dashboard/paymentCard.svg';
import messages from '../locale/messages';

export function getCardsDetails(formatMessage) {
    const cardsInfo = [
        {
            title: formatMessage(messages.myBookings),
            icon: bookingCard,
            content: formatMessage(messages.bookingContent),
            link: '/bookings/upcoming'
        },
        {
            title: formatMessage(messages.paymentMethodText),
            icon: paymentCard,
            content: formatMessage(messages.paymentContent),
            link: '/payment-method'
        },
        {
            title: formatMessage(messages.profile),
            icon: profileCard,
            content: formatMessage(messages.profileContent),
            link: '/profile'
        }
    ];

    return cardsInfo;
}
